import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {JSONDataService, DEFAULT_COUNTRY_CODE, Country, DEFAULT_LANG} from '../data';
import { Nullable } from '../reusables/helpers/types';
import { getBrowserCountryCode } from '../reusables/helpers/browser';


@Injectable({
    providedIn: 'root'
})
export class CountryState {

    /** JSON data service DI. */
    private readonly _jsonDataService: JSONDataService = inject(JSONDataService);

    /** User country. */
    private _userCountrySgl: WritableSignal<Nullable<Country>> = signal(null);

    /** App Initializer. */
    async init(): Promise<boolean> {
        const supportedCountries: Country[] = await firstValueFrom(
            this._jsonDataService.getDataCollection<Country>('stellantis_rappel_202503_pays.json'));

        /** Get lang by parsing url. */
        function __getLangFromUrl(url: string): Nullable<string> {
            const urlParts = url.split('/');
            for (const part of urlParts) {
                if (supportedCountries.map(c => c.code.toLowerCase()).includes(part.toLowerCase())) {
                    return part;
                }
            }
            return null;
        }

        const urlCountryCode: Nullable<string> = __getLangFromUrl(document.location.href);
        this._userCountrySgl.set(
            supportedCountries.find(c => c.code.toLowerCase() === urlCountryCode?.toLowerCase())
            ?? supportedCountries.find(c => c.code.toLowerCase() === getBrowserCountryCode())
            ?? supportedCountries.find(c => c.code.toLowerCase() === DEFAULT_COUNTRY_CODE)
        );

        return true;
    }

    /** (Get) Country. */
    get country(): Nullable<Country> {
        return this._userCountrySgl();
    }

    /** (Get) Country code. */
    get countryCode(): string {
        return this.country?.code ?? DEFAULT_COUNTRY_CODE;
    }

    /** (Get) Country code. */
    get langCode(): string {
        return this.country?.code_lang ?? DEFAULT_LANG;
    }
}
